// Components

import { styled, css } from "../../../../../../styles";

export const Container = styled("div", {
  width: 325,
  height: "max-content",
  borderRadius: 8,

  backgroundColor: "$white",
  boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.20)",

  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: 10,

  position: "relative",

  padding: "22px 20px",
});

export const Title = styled("div", {
  width: "100%",
  textAlign: "center",

  color: "$black",
  fontFamily: "$openSans",
  fontSize: 14,
  fontWeight: 500,

  marginBottom: 10,
});

export const SelectContainer = styled("div", {
  width: "100%",
  height: "max-content",

  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: 8,

  position: "relative",

  p: {
    color: "$charcoal",
    fontFamily: "$openSans",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: "500",
  },

  ".ant-select-single": {
    height: "42px!important",
  },

  ".ant-select": {
    width: "100% !important",
  },

  ".ant-picker": {
    border: "1px solid var(--colors-gray-50) !important",
  },

  textarea: {
    width: "100% !important",
    minHeight: "81px",
    height: "fit-content",
    paddingLeft: "11px",
  },

  variants: {
    isError: {
      true: {
        ".ant-select-selector": {
          borderColor: "$error-lighter !important",

          "&:hover": {
            borderColor: "$error-lighter !important",
          },
        },

        textarea: {
          borderColor: "$error-lighter !important",
        },
      },
    },
  },
});

export const OptionsContainer = styled("div", {
  width: "100%",

  display: "flex",
  justifyContent: "space-between",
  gap: 8,
});

export const BottomContainer = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  bottom: "20px",

  paddingTop: "5px",
});

export const TrueOrFalseBox = styled("div", {
  width: "132px",
  height: "32px",
  borderRadius: 6,

  color: "$success-dark",
  backgroundColor: "rgba(10, 171, 81, 0.2)",

  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: 500,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  variants: {
    isRed: {
      true: {
        backgroundColor: "rgba(225, 29, 63, 0.2)",
        color: "$error-darker",
      },
    },
  },
});

// CSS

export const TextFieldCss = css({
  width: "132px !important",
});

export const popupOptionsCss = css({
  zIndex: 3001,
  pointerEvents: "auto",
  fontFamily: "$openSans !important",

  ".ant-select-item-option-selected": {
    backgroundColor: "$primary-20 !important",

    svg: {
      color: "$primary",
    },
  },

  ".ant-select-item-option-content": {
    fontFamily: "$openSans",
    color: "$black !important",
    fontWeight: "500 !important",
  },
});
